import { render, staticRenderFns } from "./ProfilePPPCards.vue?vue&type=template&id=5344df32&"
import script from "./ProfilePPPCards.vue?vue&type=script&lang=js&"
export * from "./ProfilePPPCards.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePPPCards.vue?vue&type=style&index=0&id=5344df32&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports